/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesearchlabel3Inputs */

const en_ticketpagesearchlabel3 = /** @type {(inputs: Ticketpagesearchlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search orders`)
};

const de_ticketpagesearchlabel3 = /** @type {(inputs: Ticketpagesearchlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen durchsuchen`)
};

/**
* | output |
* | --- |
* | "Search orders" |
*
* @param {Ticketpagesearchlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesearchlabel3 = /** @type {((inputs?: Ticketpagesearchlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesearchlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesearchlabel3(inputs)
	return de_ticketpagesearchlabel3(inputs)
});
export { ticketpagesearchlabel3 as "ticketPageSearchLabel" }